import { Component, OnDestroy } from '@angular/core';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';

import { Breadcrumb } from './breadcrumb';
import { BreadcrumbService } from './breadcrumb.service';
import { Subscription } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-bread-crumb',
  styleUrls: ['./breadcrumb.scss'],
  template: `<div #template>
      <ng-content></ng-content>
    </div>
    @if (template.children.length == 0) {
<div class="container">
      <div class="nav-wrapper">
        @for (route of breadcrumbs; track route) {
<div class="breadcrumb" [ngClass]="{ last: route.terminal }">
          <!-- disable link of last item -->
          @if (!route.terminal) {
<a href="">{{ route.displayName }}</a>
}
          @if (route.terminal) {
<span>{{ route.displayName }}</span>
}
        </div>
}
      </div>
    </div>
}`,
})
export class BreadcrumbComponent implements OnDestroy{
  breadcrumbs: Breadcrumb[];
  sub: Subscription;

  constructor(private breadcrumbService: BreadcrumbService, private navigationService: NavigationService) {
    this.sub = breadcrumbService.breadcrumbChanged.subscribe((crumbs: Breadcrumb[]) => {
      this.onBreadcrumbChange(crumbs);
    });
  }

  ngOnDestroy(): void {
      this.sub.unsubscribe();
  }

  private onBreadcrumbChange(crumbs: Breadcrumb[]) {
    this.breadcrumbs = crumbs;
  }
}
